{
  "title": "Global Rank",
  "subtitle": "One ranking, human managers only. Points from race results, halved every season: recent form always counts most.",
  "loadError": "Couldn't load Global Rank. Please try again.",
  "retry": "Try again",
  "youBadge": "You",
  "rookieBadge": "Rookie",
  "scoreUnit": "pts",
  "placesUnit": "places",
  "divisionAll": "All divisions",
  "division": "Division {n}",
  "divisionSelectLabel": "Division",
  "searchPlaceholder": "Search teams...",
  "noMatch": "No teams match your search",
  "noData": "No Global Rank data yet",
  "thTeam": "Manager & team",
  "thDivision": "Division",
  "thScore": "Points",
  "newBadge": "NEW",
  "newBadgeTooltip": "No previous weekly snapshot yet, shown after next week's update.",
  "movementUpTooltip": "Up {n} place(s) since last week",
  "movementDownTooltip": "Down {n} place(s) since last week",
  "prevPage": "Previous",
  "nextPage": "Next",
  "pageOf": "Page {page} of {total}",
  "legendFormula": "Human managers only, ranked by points from race results, halved at every season change so recent form always counts most. Managers inactive for 2+ seasons are hidden (their points are kept).",
  "climbersTitle": "Climbers of the season",
  "climbersEmpty": "No movement yet this season",
  "bestNewManagerTitle": "Best new manager",
  "bestNewManagerEmpty": "No rookies ranked yet"
}
